module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Food/Chicken-b1fb71d161b8d4e914ba78dbcdf1ee06.svg";